import Vue from "vue";
import App from "./App.vue";
import VueResource from "vue-resource";

Vue.use(VueResource);

var PARGO_AJAX_URL = process.env.APP_URL;
init();

function init () {
  //Only on Shopify Plus do we set this item in the localstorage
  //If it is a Shopify plus order I return here because I dont want the plugin to be initialized on the thank-you page
  //@TODO: This is a temporary solution, pulling from database-returned order object is a better way to go.
  let isShopifyPlusOrder = localStorage.getItem(`pargo-checkout:${window.Shopify.Checkout.token}`);
  if (isShopifyPlusOrder) {
    return;
  }

  if (Shopify.checkout === undefined) {
    return;
  }
  if (Shopify.Checkout.requiresShipping == false) {
    return;
  }
  if (Shopify.checkout.shipping_rate) {

    if (!Shopify.checkout.shipping_rate.handle.toLowerCase().includes("pargo")) {
      return;
    }

  } else if (Shopify.checkout.shipping_rate === null) {
    return;
  }

  Vue.config.devtools = false;
  Shopify.Checkout.OrderStatus.addContentBox(
    `<div id="plugin"></div>`
  );
  var app = new Vue({
    el: "#plugin",
    render: h => h(App)
  });
}
